import classNames from 'classnames/bind';
import styles from './Main.module.css';

import { Link } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../../hooks/useRedux';
import { selectUser } from '../../../features/authSlice';

import {
  CLASSROOM,
  LEARNING_ACTIVITY,
  CLASS_INFORMATION,
  CLASS_MANAGEMENT,
  TEACHER_INFORMATION,
  MY_ACTIVITY_INFO,
  CLASS_ACTIVITY_INFO,
  EBOOK_ACTIVITY_INFO,
  STUDENT_BULK_ADD,
} from '../../../constants';
import { isMobile } from '../../../utils/util';
import {
  selectStudentCount,
  studentCountChanged,
  studentMaxStudentChanged,
} from '../../../features/classroomSlice';
import { useGetMainMutation } from '../../../services/main';
import { useEffect } from 'react';

export default function Main() {
  const cx = classNames.bind(styles);
  const dispatch = useAppDispatch();

  const user = useAppSelector(selectUser);
  const studentCnt = useAppSelector(selectStudentCount);

  const [getMain] = useGetMainMutation();

  const list = [
    {
      name: LEARNING_ACTIVITY,
      subList: [
        { name: MY_ACTIVITY_INFO, path: 'my-activity-info' },
        ...(user?.type === 1
          ? [
              { name: CLASS_ACTIVITY_INFO, path: 'class-activity-info' },
              { name: EBOOK_ACTIVITY_INFO, path: 'ebook-activity-info' },
            ]
          : []),
      ],
    },
    {
      name: CLASS_MANAGEMENT,
      subList: [
        ...(user?.type === 1
          ? [{ name: CLASS_INFORMATION, path: 'class' }]
          : []),
        { name: TEACHER_INFORMATION, path: 'teacher' },
        // TODO: 특정 멤버십 조건 확인
        ...(isMobile || user?.type === 2
          ? []
          : [{ name: STUDENT_BULK_ADD, path: 'student-bulk-add' }]),
      ],
    },
  ];

  useEffect(() => {
    const fetchMainData = async () => {
      try {
        const res = await getMain();

        if (!('data' in res)) {
          console.warn('No data received from getMain');
          return;
        }

        const { countStudent, maxStudent } = res.data;

        dispatch(studentCountChanged(countStudent));
        dispatch(studentMaxStudentChanged(maxStudent));
      } catch (error) {
        console.error('Failed to get main', error);
      }
    };
    fetchMainData();
  }, []);

  return (
    <>
      {!isMobile && <h2 className={cx('title')}>{CLASSROOM}</h2>}
      {list.map(({ name, subList }) => (
        <div key={name} className={cx('sub_area')}>
          <p>{name}</p>
          <ul>
            {subList.map(({ name, path }) => (
              <Link
                key={name}
                to={path}
                className={cx({
                  'is--disabled':
                    (name === CLASS_ACTIVITY_INFO ||
                      name === EBOOK_ACTIVITY_INFO) &&
                    user?.type === 1 &&
                    studentCnt <= 0,
                })}
              >
                <li key={name} className={cx('items')}>
                  <span>{name}</span>
                </li>
              </Link>
            ))}
          </ul>
        </div>
      ))}
    </>
  );
}
